import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserProfileComponent } from './modules/user-profile/user-profile.component';
import { AccountComponent } from './modules/user-profile/components/account/account.component';
import { AccountDetailsComponent } from './modules/user-profile/components/account/account-details/account-details.component';
import { OrganizationRoleManagementComponent } from './modules/user-profile/components/account/organizations-roles/organization-role-management/organization-role-management.component';
import { RolePermissionComponent } from './modules/user-profile/components/account/role-management/role-permission/role-permission.component';
import { RouterTestingModule } from '@angular/router/testing';
import { ContactVerificationContainerComponent } from './modules/user-profile/components/account/contact-verification/contact-verification-container.component';
import { RoleRequestContainerComponent } from './modules/user-profile/components/account/role-request/role-request-container/role-request-container.component';
import { RoleRequestOverviewComponent } from './modules/user-profile/components/account/role-request/role-request-overview/role-request-overview.component';
import { RoleRequestHomeComponent } from './modules/user-profile/components/account/role-request/role-request-home/role-request-home.component';
import { RoleRequestNewRoleComponent } from './modules/user-profile/components/account/role-request/role-request-new-role/role-request-new-role.component';
import { RoleRequestRemoveRoleComponent } from './modules/user-profile/components/account/role-request/role-request-remove-role/role-request-remove-role.component';
import { RoleRequestManageRequestComponent } from './modules/user-profile/components/account/role-request/role-request-manage-request/role-request-manage-request.component';
import { RoleRequestAddEmployeeRoleComponent } from './modules/user-profile/components/account/role-request/role-request-add-employee-role/role-request-add-employee-role.component';
import { RoleRequestAdvancedSearchComponent } from './modules/user-profile/components/account/role-request/role-request-advanced-search/role-request-advanced-search.component';
import { RoleRequestRemoveEmployeeRoleComponent } from './modules/user-profile/components/account/role-request/role-request-remove-employee-role/role-request-remove-employee-role.component';
import { RoleRequestEmployeeOverviewComponent } from './modules/user-profile/components/account/role-request/role-request-employee-overview/role-request-employee-overview.component';
import { RoleRequestSuccessComponent } from './modules/user-profile/components/account/role-request/role-request-success/role-request-success.component';

const routes: Routes = [
  { path: '', redirectTo: 'user-profile/account', pathMatch: 'full' },
  { path: 'contact-verification', component: ContactVerificationContainerComponent },
  { path: 'contact-verification/error/', component: ContactVerificationContainerComponent },
  { path: 'contact-verification/error', component: ContactVerificationContainerComponent, },
  // When a hosting app with url='http://localhost:4200/user-profile' is reloaded(F5) and ArmWebComponent through 
  // ngOnChanges in user-profile-element.component.ts navigates to: 'user-profile/?token=null'. 
  // Without the route below we get error: Cannot match any routes. URL Segment: '' - kevin.low 05/16/23
  { path: 'user-profile', redirectTo: 'user-profile/account', pathMatch: 'full' },
  { path: 'role-management', redirectTo: 'user-profile/account/account-details/role-request', pathMatch: 'full' },
  // TODO: Investigate why user-profile/role-management route doesn't work in ArmWeb. It works in 
  // ArmWebComponent itself but when deployed to ArmWeb it's not working. - kevin.low 01/27/25
  { path: 'user-profile/role-management', redirectTo: 'user-profile/account/account-details/role-request', pathMatch: 'full' },
  // TODO: user-profile/account and user-profile/account/role-request are just like
  // user-profile/role-management. Once that works, these should work as well but
  // these 2 routes don't work in ArmWeb. - kevin.low 01/27/25
  // { path: 'user-profile/account', redirectTo: 'user-profile/account', pathMatch: 'full' },
  // { path: 'user-profile/account/role-management', redirectTo: 'user-profile/account/account-details/role-request/request-new-role', pathMatch: 'full' },
  { path: 'user-profile', component: UserProfileComponent,
  children: [
    {
      path: 'account',
      component: AccountComponent,
      data: {
        breadcrumb: [{ label: 'User Profile', url: 'account' }],
      },
    },
    {
      path: 'account/account-details',
      component: AccountDetailsComponent,
      children: [
        {
          path: 'organizations-roles',
          component: OrganizationRoleManagementComponent,
          data: {
            breadcrumb: [
              { label: 'User Profile', url: 'account' },
              {
                label: 'Organizations and Role Management',
                url: 'account-details/organizations-roles',
              },
            ],
            },
        },
        {
            path: 'role-permission',
            component: RolePermissionComponent,
            data: {
              breadcrumb: [
                { url: 'account', label: 'User Profile' },
                {
                  url: 'account/account-details/organizations-roles',
                  label: 'Organizations and Role Management',
                },
                {
                  url: 'account/account-details/role-permission',
                  label: 'Role Permission',
                },
              ]
            }
        },
        {
          path: 'role-request',
          component: RoleRequestContainerComponent,
          children: [
            {
              path: '',
              component: RoleRequestHomeComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  }
                ]
              }
            },
            {
              path:'role-overview',
              component: RoleRequestOverviewComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/role-overview',
                    label: 'Role Overview',
                  }
                ]
              }
            },
            {
              path:'request-new-role',
              component: RoleRequestNewRoleComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/request-new-role',
                    label: 'Request New Role',
                  }
                ]
              }
            },
            {
              path:'remove-role',
              component: RoleRequestRemoveRoleComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/remove-role',
                    label: 'Remove Role',
                  }
                ]
              }
            },
            {
              path:'manage-role-request',
              component: RoleRequestManageRequestComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/manage-role-request',
                    label: 'Manage Request and Existing Roles',
                  }
                ]
              }
            },
            {
              path:'add-employee-role',
              component: RoleRequestAddEmployeeRoleComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/add-employee-role',
                    label: 'Add Employee Role',
                  }
                ]
              }
            },
            {
              path:'advanced-search',
              component: RoleRequestAdvancedSearchComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/add-employee-role',
                    label: 'Add Employee Role',
                  },
                  {
                    url: 'account/account-details/advanced-search',
                    label: 'Advanced Search',
                  }
                ]
              }
            },
            {
              path:'remove-employee',
              component: RoleRequestRemoveEmployeeRoleComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/remove-employee',
                    label: 'Remove Role',
                  }
                ]
              }
            },
            {
              path:'employee-role-overview',
              component: RoleRequestEmployeeOverviewComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/employee-role-overview',
                    label: 'Employee Role Overview',
                  }
                ]
              }
            } ,
            {
              path:'role-request-success',
              component: RoleRequestSuccessComponent,
              data: {
                breadcrumb: [
                  { url: 'account', label: 'User Profile' },
                  {
                    url: 'account/account-details/role-request',
                    label: 'Role Management',
                  },
                  {
                    url: 'account/account-details/role-request-success',
                    label: 'Employee Role Overview',
                  }
                ]
              }
            } 
          ]
      },
        {
          path: 'contact-verification',
          component: ContactVerificationContainerComponent,
          data: {
            breadcrumb: [
              { label: 'User Profile', url: 'account' },
              {
                label: 'Contact Verification',
                url: 'account-details/contact-verification',
              },
            ],
          },
        },
      ]
    }
  ]
  }
];

@NgModule({
  imports: [RouterTestingModule.withRoutes(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
